import { computed, Directive, signal } from '@angular/core';

@Directive({
	selector: '[ifHasChildPermission]',
	standalone: true,
	host: {
		'[hidden]': '!shouldRender()'
	}
})
export class IfHasChildPermissionDirective {
	private readonly evaluators = signal<readonly (() => boolean)[]>([]);

	public readonly shouldRender = computed(() => {
		const evals = this.evaluators();
		if (evals.length === 0) return true;
		return evals.some(evaluate => evaluate());
	});

	public register(evaluator: () => boolean): void {
		this.evaluators.update(list => [...list, evaluator]);
	}

	public unregister(evaluator: () => boolean): void {
		this.evaluators.update(list => list.filter(e => e !== evaluator));
	}
}
